export const navigatorState = ({ totalPages = 0, perPage = 10, actualPage = 0 }) => ({
  totalPages,
  perPage,
  actualPage
})

export const navigatorGetters = () => ({
  TOTAL_PAGE: (state) => state.totalPages,
  PER_PAGE: (state) => state.perPage,
  ACTUAL_PAGE: (state) => state.actualPage
})

export const navigatorMutations = () => ({
  TOTAL_PAGE: (state, totalRegister) => { state.totalPages = Math.floor(totalRegister / state.perPage) },
  PER_PAGE: (state, perPage) => { state.perPage = perPage },
  ACTUAL_PAGE: (state, actualPage) => { state.actualPage = actualPage }
})

export const navigatorSkip = (state) => state.actualPage * state.perPage
export const navigatorLimit = (state) => state.perPage



// WEBPACK FOOTER //
// ./src/components/primitives/paginator/stored-navigator-store/index.js